// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"14aaeb39","89":"cdc377f2","375":"c820d720","542":"1191c9db","811":"4dc81eb3"}[chunkId] + ".chunk.css";
};